import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  UploadResult,
} from 'firebase/storage';

import { storage } from './config';

/**
 * Upload file to Firebase Storage
 * Returns download URL
 */
export async function uploadFile(
  path: string,
  file: File | Blob,
  metadata?: { contentType?: string; customMetadata?: Record<string, string> }
): Promise<string> {
  const storageRef = ref(storage, path);
  const uploadResult: UploadResult = await uploadBytes(
    storageRef,
    file,
    metadata
  );
  const downloadURL = await getDownloadURL(uploadResult.ref);
  return downloadURL;
}

/**
 * Delete file from Firebase Storage
 */
export async function deleteFile(path: string): Promise<void> {
  const storageRef = ref(storage, path);
  await deleteObject(storageRef);
}

/**
 * Get download URL for a file
 */
export async function getFileURL(path: string): Promise<string> {
  const storageRef = ref(storage, path);
  return await getDownloadURL(storageRef);
}

/**
 * Storage path builders following constitution guidelines
 */
export const StoragePaths = {
  waiver: (userId: string, bookingId: string): string =>
    `waivers/${userId}/${bookingId}/waiver.pdf`,
  bikeImage: (bikeId: string, imageId: string): string =>
    `bikes/${bikeId}/${imageId}.webp`,
  locationImage: (locationId: string, imageId: string): string =>
    `locations/${locationId}/${imageId}.webp`,
  productImage: (productId: string, imageId: string): string =>
    `products/${productId}/${imageId}.webp`,
  damageReport: (reportId: string, imageId: string): string =>
    `damage_reports/${reportId}/${imageId}.jpg`,
  profileImage: (userId: string): string => `profile_images/${userId}/avatar.jpg`,
  hubRequestImage: (requestId: string, imageId: string): string =>
    `hub_requests/${requestId}/${imageId}.jpg`,
  homePageImage: (fileName: string): string =>
    `home/${fileName}`,
  landingPageImage: (pageId: string, fileName: string): string =>
    `landing/${pageId}/${fileName}`,
  blogFeaturedImage: (postId: string, fileName: string): string =>
    `blog/${postId}/featured-${fileName}`,
  blogInlineImage: (postId: string, fileName: string): string =>
    `blog/${postId}/inline-${fileName}`,
  siteAsset: (assetType: string, fileName: string): string =>
    `site/${assetType}/${fileName}`,
} as const;

